if (!customElements.get('product-quick-add')) {
  class ProductQuickAdd extends HTMLElement {
    constructor() {
      super();
      
      this.qtyInput = this.querySelector('.product-modal__qty-input');
      this.variantIdInput = this.querySelector('.product-modal__variant-id');
      this.priceSale = this.querySelector('.price-item--sale');
      this.priceCompare = this.querySelector('.price-item--regular');
      this.addButton = this.querySelector('.product-modal__add-btn');
      
      // Quantity buttons
      this.querySelectorAll('.product-modal__qty-btn').forEach(btn => {
        btn.addEventListener('click', this.onQtyClick.bind(this));
      });

      // Variant selection
      const jsonEl = this.querySelector('.product-modal__variants-json');
      this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      this.addEventListener('change', this.onVariantChange.bind(this));

      // Form submission handler
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.submitModalForm(this.form);
        });
      }
    }

    onQtyClick(event) {
      const action = event.currentTarget.dataset.action;
      let currentVal = parseInt(this.qtyInput.value) || 1;
      if (action === 'plus') {
        this.qtyInput.value = currentVal + 1;
      } else if (action === 'minus' && currentVal > 1) {
        this.qtyInput.value = currentVal - 1;
      }
    }

    onVariantChange() {
      // Find selected values
      const selectedOptions = Array.from(this.querySelectorAll('.product-modal__option-input:checked')).map(input => input.value);
      
      // Find matching variant
      const matchedVariant = this.variantData.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (matchedVariant) {
        this.variantIdInput.value = matchedVariant.id;
        
        // Update price
        this.priceSale.textContent = this.formatMoney(matchedVariant.price);
        if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
          if (this.priceCompare) {
            this.priceCompare.textContent = this.formatMoney(matchedVariant.compare_at_price);
            this.priceCompare.style.display = '';
          }
        } else if (this.priceCompare) {
          this.priceCompare.style.display = 'none';
        }

        // Update button state
        if (matchedVariant.available) {
          this.addButton.querySelector('span').textContent = 'Add To Cart';
          this.addButton.removeAttribute('disabled');
        } else {
          this.addButton.querySelector('span').textContent = 'Sold Out';
          this.addButton.setAttribute('disabled', 'disabled');
        }
      } else {
        // Variant doesn't exist
        this.addButton.querySelector('span').textContent = 'Unavailable';
        this.addButton.setAttribute('disabled', 'disabled');
      }
    }

    formatMoney(cents) {
      const currency = window.Shopify?.currency?.active || 'USD';
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: currency
      });
    }

    submitModalForm(form) {
      if (this.addButton && (this.addButton.hasAttribute('disabled') || this.addButton.getAttribute('aria-disabled') === 'true')) {
        return;
      }
      const spinner = this.addButton ? this.addButton.querySelector('.loading-overlay__spinner') : null;
      const textSpan = this.addButton ? this.addButton.querySelector('span') : null;
      
      if (this.addButton) this.addButton.setAttribute('disabled', 'disabled');
      if (spinner) spinner.classList.remove('hidden');
      if (textSpan) textSpan.classList.add('hidden');

      const cart = document.querySelector('cart-drawer');
      const formData = new FormData(form);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      fetch(window.routes?.cart_add_url || '/cart/add.js', config)
        .then(res => res.json())
        .then(response => {
          if (response.status) {
            alert(response.description);
          } else {
            // Close modal
            const modal = this.closest('product-quick-add-modal') || this.closest('product-modal');
            if (modal) {
              if (typeof window.closeModal === 'function') {
                window.closeModal(modal);
              } else {
                modal.removeAttribute('open');
                document.body.style.overflow = 'unset';
              }
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-quick-add' });
            }

            if (cart) {
              cart.renderContents(response);
              if (cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
            }
          }
        })
        .catch(err => console.error(err))
        .finally(() => {
          if (this.addButton) this.addButton.removeAttribute('disabled');
          if (spinner) spinner.classList.add('hidden');
          if (textSpan) textSpan.classList.remove('hidden');
          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        });
    }
  }

  customElements.define('product-quick-add', ProductQuickAdd);
}

if (!window.productModalLatestInitialized) {
  window.productModalLatestInitialized = true;

  window.closeModal = function(modal) {
    if (!modal || modal.classList.contains('closing')) return;
    modal.classList.add('closing');
    setTimeout(() => {
      modal.removeAttribute('open');
      modal.classList.remove('closing');
      document.body.style.overflow = 'unset';
      // Restore modal to its original DOM position
      if (modal._originalParent) {
        if (modal._originalNextSibling && modal._originalNextSibling.parentNode === modal._originalParent) {
          modal._originalParent.insertBefore(modal, modal._originalNextSibling);
        } else {
          modal._originalParent.appendChild(modal);
        }
      }
    }, 250);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-button-modal]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      const modalId = button.dataset.buttonModal;
      const modal = document.getElementById(modalId);

      if (!modal) return;

      const hasAttr = modal.hasAttribute('open');

      if (hasAttr) {
        window.closeModal(modal);
        return;
      }

      // Store original position so we can restore it on close
      if (!modal._originalParent) {
        modal._originalParent = modal.parentNode;
        modal._originalNextSibling = modal.nextSibling;
      }
      // Move modal to body so position:fixed works even inside transformed ancestors (e.g. UIKit slider)
      document.body.appendChild(modal);

      modal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      return;
    }

    // Close modal when clicking on backdrop
    if (event.target.classList.contains('product-modal__backdrop')) {
      const modal = event.target.closest('product-quick-add-modal') || event.target.closest('product-modal');
      if (modal) {
        window.closeModal(modal);
      }
    }
  });
}

if (!customElements.get('desktop-quick-add')) {
  class DesktopQuickAdd extends HTMLElement {
    constructor() {
      super();
      
      const toggleBtn = this.querySelector('[data-action="toggle-variants"]');
      const overlay = this.querySelector('.desktop-quick-add__variants-overlay');
      
      if (toggleBtn && overlay) {
        toggleBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isClosed = overlay.classList.contains('hidden');
          if (isClosed) {
            overlay.classList.remove('hidden');
            this.classList.add('has-open-overlay');
          } else {
            overlay.classList.add('hidden');
            this.classList.remove('has-open-overlay');
          }
        });
        
        // Hide overlay when clicking outside
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            overlay.classList.add('hidden');
            this.classList.remove('has-open-overlay');
          }
        });
      }

      // Add to cart click handler for variants
      this.querySelectorAll('.desktop-quick-add__variant-pill').forEach(pill => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (pill.hasAttribute('disabled') || pill.classList.contains('is-sold-out')) return;
          this.querySelectorAll('.desktop-quick-add__variant-pill').forEach(p => p.classList.remove('is-active'));
          pill.classList.add('is-active');
          this.addVariantToCart(pill);
        });
      });
      
      // AJAX form submission for single variant products
      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.submitSingleProductForm(form);
        });
      }
    }

    addVariantToCart(pill) {
      const variantId = pill.dataset.variantId;
      const textSpan = pill.querySelector('.desktop-quick-add__variant-title-text');
      const spinner = pill.querySelector('.loading-overlay__spinner');

      pill.classList.add('is-loading');
      pill.setAttribute('disabled', 'disabled');
      if (textSpan) textSpan.style.opacity = 0;
      if (spinner) spinner.classList.remove('hidden');

      const cart = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      fetch(window.routes?.cart_add_url || '/cart/add.js', config)
        .then(res => res.json())
        .then(response => {
          if (response.status) {
            alert(response.description);
          } else {
            // Trigger cart refresh
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'desktop-quick-add' });
            }
            if (cart) {
              cart.renderContents(response);
              if (cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
            }
            // Hide overlay
            const overlay = this.querySelector('.desktop-quick-add__variants-overlay');
            if (overlay) {
              overlay.classList.add('hidden');
              this.classList.remove('has-open-overlay');
            }
          }
        })
        .catch(err => console.error(err))
        .finally(() => {
          pill.classList.remove('is-loading');
          pill.removeAttribute('disabled');
          if (textSpan) textSpan.style.opacity = 1;
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        });
    }

    submitSingleProductForm(form) {
      const submitBtn = form.querySelector('.desktop-quick-add__btn');
      if (submitBtn && (submitBtn.hasAttribute('disabled') || submitBtn.getAttribute('aria-disabled') === 'true')) {
        return;
      }
      const spinner = form.querySelector('.loading-overlay__spinner');
      
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      if (spinner) spinner.classList.remove('hidden');

      const cart = document.querySelector('cart-drawer');
      const formData = new FormData(form);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
      }

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      fetch(window.routes?.cart_add_url || '/cart/add.js', config)
        .then(res => res.json())
        .then(response => {
          if (response.status) {
            alert(response.description);
          } else {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'desktop-quick-add' });
            }
            if (cart) {
              cart.renderContents(response);
              if (cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
            }
          }
        })
        .catch(err => console.error(err))
        .finally(() => {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
        });
    }
  }

  customElements.define('desktop-quick-add', DesktopQuickAdd);
}